// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__pXWHr","image":"Image_image__nwkY2","featured":"Image_featured__H+wOL","showOnMobileOnly":"Image_showOnMobileOnly__jiw+7"};